import "./GhostContainerComponent.scss";
import template from "./GhostContainerComponent.html";
import {IComponentOptions} from "angular";

export const GhostContainer = "tfGhostContainer";

export function ghostContainer(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: GhostContainerComponentController
    };
}

export class GhostContainerComponentController {

    /** @ngInject */
    public constructor() {

    }
}
